import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useGetBuyerTransferDocumentUrlQuery } from 'services/api/transfer-report';
import { DocumentList } from 'pages/Admin/TransferReport/DocumentPage/DocumentList';

const SITE_HEADER_HEIGHT = 72;

const Container = styled.div`
  height: calc(100vh - ${SITE_HEADER_HEIGHT}px);
  overflow-y: auto;
  background: #fff;
`;

const BuyerTransferDocumentPage = () => {
  const { reportId } = useParams<{ reportId: string }>();
  const { data = { documents: [], logs: [] } } = useGetBuyerTransferDocumentUrlQuery(Number(reportId));

  return (
    <Container>
      <DocumentList data={data.documents} />
    </Container>
  );
};

export default BuyerTransferDocumentPage;
